export default {"src":"/_next/static/media/disasterRecoverySecure.8950b26b.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};